module.exports = __webpack_public_path__ + "static/media/LightningIcon.47924314.svg";